import axios from "axios";
import AuthService from "../login/auth.service";
import { dimo, cuentas, comprobantes } from "../../components/generico/utils/UrlAPI";

class PagoServicioServiceV2 {
    constructor(props) {
        this.reemplazarPunto = this.reemplazarPunto.bind(this);
        this.reemplazarBarra = this.reemplazarBarra.bind(this);
    }
    async getCuentasSocio() {
        var data = JSON.stringify({
            canal: "WEB",
            estado: null,
            modalidad: null,
            moneda: "GS",
            tipo: "D",
            tipoCuenta: null
        });
        var config = {
            method: "post",
            url: cuentas + "socio-cuenta/transferencias",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + AuthService.getCurrentToken(),
            },
            data: data,
        };
        return await axios(config);
    }

    async getTarjetasCabal() {
        var config = {
            method: "POST",
            url: dimo + "dimoTarjetas/getTarjetasPanalCabal",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + AuthService.getCurrentToken()
            },
            data: {
                canal: "WEB"
            }
        };
        return await axios(config);
    }

    async listarServicios() {
        let url = `${dimo}pago-servicio/lista-servicios`;
        console.log(url);
        let config = {
            method: 'get',
            url: url,
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + AuthService.getCurrentToken(),
                Accept: '*/*'
            },
            timeout: 100000,
        };
        return await axios(config);
    }

    async listarServiciosFiltro(data) {
        let body = JSON.stringify({
            posInicial: '',
            cantidad: '',
            paymentEntityName: ''
        })
        let config = {
            method: 'post',
            url: dimo + 'lista-servicios-filtro',
            data: body,
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + AuthService.getCurrentToken()
            },
            timeout: 100000,
        };
        return await axios(config);
    }

    async listarParametros(data) {
        let config = {
            method: 'post',
            url: dimo + 'pago-servicio/lista-parametros',
            data: data,
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + AuthService.getCurrentToken(),
                Accept: '*/*'
            },
            timeout: 100000,
        };
        return await axios(config);
    }

    async listarFacturas(data) {
        let url = `${dimo}pago-servicio/lista-facturas`;
        let config = {
            method: 'POST',
            url: url,
            data: data,
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + AuthService.getCurrentToken(),
                Accept: '*/*'
            },
            timeout: 100000,
        };
        return await axios(config);
    }

    async obtenerComision(data) {
        let url = `${dimo}pago-servicio/obtener-comision`;
        let config = {
            method: 'POST',
            url: url,
            data: data,
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + AuthService.getCurrentToken()
            },
            timeout: 100000,
        };
        return await axios(config);
    }

    async pagarServicio(data) {
        let url = `${dimo}pago-servicio/pagar-servicio`
        let config = {
            method: 'POST',
            url: url,
            data: data,
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + AuthService.getCurrentToken(),
                Accept: '*/*'
            },
            timeout: 100000,
        };
        return await axios(config);
    }

    reemplazarPunto(valor) {

        var resultado = valor.replace(".", "");
        var original = resultado;
        var reemplazo = true;
        while (reemplazo) {
            resultado = resultado.replace(".", "");
            if (resultado === original)
                reemplazo = false;
            else
                original = resultado;
        }
        return resultado;
    };

    reemplazarBarra(valor) {

        var resultado = valor.replace("/", "");
        var original = resultado;

        var reemplazo = true;
        while (reemplazo) {
            resultado = resultado.replace("/", "");
            if (resultado === original)
                reemplazo = false
            else
                original = resultado

        }
        var fecha = original.substring(0, original.length - 4)
        fecha = fecha + original.substring(original.length - 2, original.length) + "000000"

        return fecha;
    };

    async descargarComprobante(data){
        let url = `${comprobantes}comprobantes/pagos-servicios-cabal`;
        let config = {
            method : 'POST',
            url : url,
            data: data,
            responseType: "blob",
            headers:{
                'Content-Type' : 'application/json',
                Authorization : 'Bearer ' + AuthService.getCurrentToken()
            },
            timeout : 100000,
        };
        return await axios(config);
    }

    async listarComprobantes(data) {
        let url = `${dimo}pago-servicio/listar-comprobantes`;
        let config = {
            method: 'POST',
            url: url,
            data: data,
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + AuthService.getCurrentToken()
            },
            timeout: 100000,
        };
        return await axios(config);
    }

}

export default new PagoServicioServiceV2();
